import { Component, Input, inject } from '@angular/core';
import { WorkflowDashboardConfiguration } from './workflow-dashboard-configuration';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthorizationService } from '@nimmsta/ng-commons-lib/auth';
import { LoadingIndicatorComponent } from '@nimmsta/ng-commons-lib/loading-indicator';
import { Workflow } from '@nimmsta/ng-commons-lib/models';
import { WorkflowService } from '@nimmsta/ng-commons-lib/services/workflow';
import { DashboardComponentInterface } from '../../../../models/dashboard';

@Component({
  selector: 'app-workflow-dashboard',
  templateUrl: './workflow-dashboard.component.html',
  imports: [RouterLink, TranslatePipe, LoadingIndicatorComponent],
})
export class WorkflowDashboardComponent implements DashboardComponentInterface {
  private authorizationService = inject(AuthorizationService);
  private workflowService = inject(WorkflowService);
  @Input() configuration!: WorkflowDashboardConfiguration;

  protected workflows: Workflow[] = [];

  protected isLoading = false;

  protected canNavigateToWorkflows =
    this.authorizationService.hasPermission('workflow.read');

  setConfiguration(configuration: unknown): void {
    this.configuration = {
      ...this.configuration,
      ...(configuration as object),
    };
  }

  loadData() {
    this.isLoading = true;
    this.workflowService.simpleList().subscribe((data) => {
      this.workflows = data;
      this.isLoading = false;
    });
  }
}
